import { Box, Typography } from "@mui/material";
import { DistributionIconsProps } from "../../api/types";


const DistributionIcons = ({
  items,
  maxVisible = 4,
}: DistributionIconsProps) => {
  const total = items.length;

  const showPlus = total > maxVisible;
  const visibleItems = showPlus ? items.slice(0, maxVisible - 1) : items;

  const extraCount = total - visibleItems.length;

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {visibleItems.map((item, index) => (
        <Box
          key={item.label}
          sx={{
            borderRadius: "50%",
            backgroundColor: "#e0f2fe",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ml: index === 0 ? 0 : -0.8,
            zIndex: visibleItems.length - index,
            overflow: "hidden",
          }}
        >
          <img
            src={item.iconUrl ?? "/bizlogo.svg"}
            alt={item.label}
            width={18}
            height={18}
            style={{ objectFit: "cover" }}
          />
        </Box>
      ))}

      {showPlus && (
        <Box
          sx={{
            width: 24,
            height: 20,
            borderRadius: "40%",
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ml: -0.8,
            zIndex: 0,
          }}
        >
          <Typography
            fontSize={11}
            fontWeight={600}
            color="#0f69aa"
            lineHeight={1}
          >
            +{extraCount}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default DistributionIcons;
